/// <field name='actions' type='Object'>Helpdesk actions object</field>
window.hdActions = cafm.hd.actions = {
    vars: {
        /// <field name='closeTimeout' type='Integer'>Common close action timeout value</field>
        closeTimeout: 2500,
        issueWindowMinHeight: 300,
        issueWindowMaxHeight: 600
    },
    initAction: viewModel => {

        // important: do this as it prevents bind related errors on action toolbar button clicks
        viewModel.submit = () => { }
        viewModel.cancel = () => { }

        // register view model with form if defined
        if (viewModel) {                        
            cafm.views.getActionForm().bindViewModel({
                viewModel: viewModel
            });
        }
        // call on load handler if defined
        if (viewModel.OnFormLoad) {
            let handler = cafm.util.getReference(viewModel.OnFormLoad, hdActions);
            if (isFunc(handler)) {
                handler(viewModel);
            }
        }
    },
    issuing: {
        init(defaultViewModel) {
            cafm.views.getActionWindowViewModel().bind("change", args => {
                if (args.field == "IssueType") {
                    let viewModel = cafm.kendo.helpers.getViewModelFromChangeArgs(args);
                    $("#issueBtn").prop("disabled", true);
                    cafm.actions.execute({
                        url: cafm.url.api("WorkOrder/GetWorkOrderIssueRecipients"),
                        values: {
                            IDs: defaultViewModel.IsMultiAction ? cafm.util.selectValue(defaultViewModel.WorkOrders, "WorkOrderID") : [viewModel.WorkOrderID],
                            IssueType: viewModel.IssueType
                        },
                        success(res) {
                            if (res) {
                                for (let i = 0; i < viewModel.Assignments.length; i++) {
                                    let resAss = cafm.util.findByFieldValue(res.Assignments, "ID", viewModel.Assignments[i].ID);
                                    let vmAss = viewModel.Assignments[i];
                                    if (resAss) {
                                        let issueType = hdActions.issuing.getIssueType(viewModel, resAss.IssueType);
                                        vmAss.IssueTypeDescription = issueType.text;
                                        vmAss.IssueType = parseInt(issueType.value);
                                        vmAss.Address = resAss.Address;
                                        vmAss.Send = resAss.Send;
                                    }
                                    else {
                                        let woIssueType = hdActions.issuing.toIssueType(viewModel.IssueType);
                                        if (!isNullOrUndefined(woIssueType)) {
                                            vmAss.IssueType = woIssueType;
                                        }
                                    }
                                }
                                for (let i = 0; i < viewModel.BusinessRoles.length; i++) {
                                    let resBr = cafm.util.findByFieldValue(res.BusinessRoles, "ID", viewModel.BusinessRoles[i].ID);
                                    let issueType = hdActions.issuing.getIssueType(viewModel, resBr.IssueType);
                                    viewModel.BusinessRoles[i].IssueTypeDescription = issueType.text;
                                    viewModel.BusinessRoles[i].IssueType = parseInt(issueType.value);
                                    viewModel.BusinessRoles[i].Address = resBr.Address;
                                    viewModel.BusinessRoles[i].Send = resBr.Send;
                                }
                                cafm.views.getActionForm().find(".k-grid").each((i, gridElement) => {
                                    $(gridElement).refreshDataSource();
                                });
                            }
                        },
                        complete() {
                            $("#issueBtn").prop("disabled", false);
                        }
                    })
                }
            });
        },
        assignmentsDataRetrieved (data) {
            if (cafm.util.hasItem(data)) {
                let viewModel = cafm.views.getActionWindowViewModel();
                data.forEach(ass => {
                    let issueType = hdActions.issuing.getIssueType(viewModel, ass.IssueType);
                    ass.IssueTypeDescription = issueType.text;
                });
                cafm.util.callFunctionAsync(hdActions.issuing.assignmentsRendered);
            }
        },
        assignmentsCheckboxSelectionChanging(recipient, selectedRows, checked, row) {
            if (checked === false && recipient.IsCustomRecipient !== true && cafm.util.count(selectedRows, ir => ir.IsCustomRecipient !== true) == 1) {
                return false;
            }
        },
        assignmentsRendered(isNewRecord) {
            let assGrid = $("#assignmentGrid").getGrid().getKendoGrid();
            assGrid.tbody.find("> tr").each((i, re) => {
                let row = $(re);
                let dataItem = assGrid.dataItem(row);
                if (dataItem.IsCustomRecipient) {
                    row.find(".k-grid-delete").css("display", "inline-flex");
                }
                if (isNewRecord && row.hasClass("k-grid-edit-row")) {
                    row.find(".grid-row-chk input").setChecked(true);
                    row.find("input[type=text]").first().focus();

                }
            });
        },
        assignmentBeforeEdit(args) {
            if (args.model.isNew()) {
                args.model.IssueType = cafm.enums.WorkOrderIssueType.Email;
                args.model.Send = true;
                args.model.IsCustomRecipient = true;
            }
            cafm.util.callFunctionAsync(hdActions.issuing.assignmentsRendered, args.model.isNew());
        },
        assignmentCancel(options) {
            cafm.util.callFunctionAsync(hdActions.issuing.assignmentsRendered);
        },
        assignmentCreate(options) {
            hdActions.issuing.assignmentUpdate(options);
        },
        assignmentDelete(options) {
            let recipient = options.data;
            let viewModel = cafm.views.getActionWindowViewModel();
            cafm.util.removeWhere(viewModel.Assignments, ass => ass.ID == recipient.ID);
            options.success(recipient);
            cafm.util.callFunctionAsync(hdActions.issuing.assignmentsRendered);
        },
        assignmentUpdate (options) {
            let viewModel = cafm.views.getActionWindowViewModel();
            let grdAss = options.data;
            let vmAss = cafm.util.findByFieldValue(viewModel.Assignments, "ID", grdAss.ID);
            let issueType = hdActions.issuing.getIssueType(viewModel, cafm.util.getItemValue(grdAss.IssueType));

            if (!vmAss) {
                grdAss.ID = cafm.guid.newGuid();
                grdAss.IssueTypeDescription = grdAss.IssueTypeDescription = issueType.text;
                grdAss.IssueType = parseInt(issueType.value);
                grdAss.IsCustomRecipient = true;
            }

            if (!hdActions.issuing.validateAssignment(grdAss)) {
                options.error(grdAss);
                return;
            }

            if (vmAss) {
                vmAss.Name = grdAss.Name;
                vmAss.Address = grdAss.Address;
                vmAss.IssueTypeDescription = grdAss.IssueTypeDescription = issueType.text;
                vmAss.IssueType = parseInt(issueType.value);
            }
            else {
                viewModel.Assignments.push(grdAss);
            }

            options.success(grdAss);
            cafm.util.callFunctionAsync(hdActions.issuing.assignmentsRendered);
        },
        issueTypeField (container, options) {

            let viewModel = cafm.views.getActionWindowViewModel();
            let ass = options.model;
            options.dropDownOptions = {
                dataSource: {
                    data: viewModel.IssueTypes.toJSON()
                }
            }
            cafm.grids.editors.dropDownEditor(container, options);
        },
        getIssueType (viewModel, issueType) {
            return cafm.util.findByFieldValue(viewModel.IssueTypes, "value", issueType.toString());
        },
        issue (args) {

            var vm = cafm.views.getActionWindowViewModel();

            if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskEditWorkOrder, cafm.enums.Navigatable.HelpdeskConfirmWorkOrder)) {
                hdActions.issue(vm);
            }
            else {
                hdActions.issueMultiple(vm)
            }
        },
        cancel: function () {
            
            hdActions.closeActionWindow();
        },
        requiresPrinting(issueInfo, isMultiIssue) {
            let printRecips = cafm.util.where(cafm.util.addAll(issueInfo.Assignments.toJSON(), issueInfo.BusinessRoles.toJSON()), ii => ii.IssueType == cafm.enums.WorkOrderIssueType.Print && ii.Send === true);
            if (isMultiIssue === true) {
                printRecips = cafm.util.where(printRecips, pr => !cafm.util.arrayContains(hdActions.failedActions, pr.WorkOrderID));
            }
            if (printRecips.length) {
                let ids = [];
                return cafm.util.selectDistinct(cafm.util.selectValue(printRecips, "WorkOrderID"), workOrderId => {
                    if (!cafm.util.arrayContains(ids, workOrderId)) {
                        ids.push(workOrderId);
                        return true;
                    }
                    else {
                        return false;
                    }
                });
            }
            else {
                return false;
            }
        },
        toIssueType(issueSelection) {
            if (isStr(issueSelection)) issueSelection = parseInt(issueSelection);
            switch (issueSelection) {
                case cafm.enums.WorkOrderIssueSelection.Email:
                    return cafm.enums.WorkOrderIssueType.Email;
                case cafm.enums.WorkOrderIssueSelection.None:
                    return cafm.enums.WorkOrderIssueType.None;
                case cafm.enums.WorkOrderIssueSelection.Print:
                    return cafm.enums.WorkOrderIssueType.Print;
            }
            return null;
        },
        validateAssignment(ass) {
            let valid = true;
            let assGrid = $("#assignmentGrid");
            let makeValid = (field, val) => {
                let input = assGrid.find(`[data-container-for=${field}] > .k-input`);
                if (val === true) {
                    input.removeClass("k-invalid")
                }
                else {
                    valid = false;
                    input.addClass("k-invalid")
                }
            }
            if (!cafm.util.hasStringVal(ass.Name)) {
                makeValid("Name", false);
            }
            else {
                makeValid("Name", true);
            }
            if (cafm.util.getItemValue(ass.IssueType) == cafm.enums.WorkOrderIssueType.Email && !cafm.util.isValidEmail(ass.Address)) {
                makeValid("Address", false);
            }
            else {
                makeValid("Address", true);
            }
            return valid;
        }
    },
    issue (workOrder, multiOptions) {
        /// <summary>Issues the work order</summary>
        /// <param name="workOrder" type="Object">Work order data</param>
        /// <param name="multiOptions" type="Object">Multiple issue options object</param>
        
        let isMulti = isDefined(multiOptions);
        let hideShowElement = $('#issueWorkOrder>.cFieldSet,#issueWorkOrder>.k-tabstrip-wrapper,.winButtons').hide();
        try {
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/Issue'),
                elementId: isMulti ? 'actionFormPlc' : cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#actionFormPlc, .winButtons #issueBtn',
                loaderText: cafm.res.str.TemplateIssuingWorkOrder0.format(workOrder.Reference),
                values: workOrder,
                preventValidate: true,
                keepMessages: true,
                executeDelay: true,
                showMessageInWindow: true,
                preventDefaultErrorHandling: isMulti,
                statusCodeFuncs: {
                    200(wo) {

                        if (wo.ConfirmationPrompt) {
                            $('.winButtons #issueBtn').hideLoader();
                            hideShowElement.show();
                            return;
                        }
                        else {
                            hideShowElement.hide();
                        }

                        if (!isMulti) {

                            // end action
                            hdActions.endAction({
                                workOrder: wo,
                                refreshForm: true,
                                preventCloseActionWindow: true
                            });

                            cafm.views.closeActionWindow();

                            // check if WO requires printing...
                            if (hdActions.issuing.requiresPrinting(workOrder)) {
                                cafm.util.callFunctionAsync({
                                    func: () => hdActions.showPrint([cafm.hd.transformToLightWorkOrder(wo)]),
                                    timeout: 500
                                });
                            }
                        }
                        else {

                            cafm.msg.prependMessagePanelTo({
                                element: $('#issueWorkOrderLoader').show(),
                                options: {
                                    Type: cafm.enums.MessageType.Success,
                                    Title: cafm.res.str.TemplateWorkOrder0Issued.format(workOrder.Reference)
                                }
                            });

                            cafm.util.callFunctionAsync({
                                func: multiOptions.callback,
                                timeout: 2000
                            });
                        }
                    }
                },
                error(response) {
                    if (isMulti) {
                        if (!hdActions.failedActions) hdActions.failedActions = [];
                        hdActions.failedActions.push(workOrder.WorkOrderID);
                        multiOptions.callback({
                            error: {
                                message: unescape(response.getResponseHeader(cafm.res.consts.ResHeader_ErrorMessage))
                            }
                        });
                    }
                    else {
                        hideShowElement.show();
                    }
                }
            });
        }
        catch (err) {
            hideShowElement.show();
        }
    },
    showIssue: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Issue'),
            values: workOrder,
            isForm: true,
            winTitle: `${cafm.res.str.TitleIssueWorkOrder} ${(isMobile ? "" : workOrder.Reference)}`.trim(),
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingIssue,
            winOptions: {
                width: cafm.util.viewPortWidth(60),
                minHeight: hdActions.vars.issueWindowMinHeight,
                maxHeight: hdActions.vars.issueWindowMaxHeight
            }
        });
    },
    showIssueMultiple: function (workOrders, endCallback) {

        if (!cafm.util.hasItem(workOrders)) return;

        workOrders = cafm.hd.transformToLightWorkOrders(workOrders);

        let title = workOrders.length < 2 ? `${cafm.res.str.TitleIssueWorkOrder} ${(isMobile ? "" : workOrders[0].Reference)}`.trim() : cafm.res.str.TitleIssueWorkOrders;
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/IssueMultiple'),
            values: workOrders,
            isForm: true,
            winTitle: title,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingIssue,
            winOptions: {
                width: cafm.util.viewPortWidth(40),
                minHeight: hdActions.vars.issueWindowMinHeight,
                maxHeight: hdActions.vars.issueWindowMaxHeight
            }
        });
    },
    issueMultiple: function (viewModel) {

        delete hdActions.failedActions;
        delete hdActions.hasActionError;
        delete hdActions.cancelAction;
        if (viewModel.WorkOrders.length == 1) {
            if (cafm.util.hasItem(viewModel.Assignments)) {
                viewModel.WorkOrders[0].Assignments = viewModel.Assignments;
            }
            if (cafm.util.hasItem(viewModel.BusinessRoles)) {
                viewModel.WorkOrders[0].BusinessRoles = viewModel.BusinessRoles;
            }
        }
        viewModel.WorkOrders.forEach(w => {
            w.IssueType = viewModel.IssueType;
            w.UpdateSLAStartDate = viewModel.UpdateSLAStartDate;
            w.CopyFacilityManager = viewModel.CopyFacilityManager;
        });
        
        hdActions.executeIssueMultiple(viewModel.WorkOrders, -1);
    },
    executeIssueMultiple: function (workOrders, actionIndex) {

        // check for cancel flag
        if (hdActions.cancelAction) {
            return;
        }
        actionIndex++;
        if (workOrders.length > actionIndex) {
            let workOrder = workOrders[actionIndex];
            hdActions.running = true;
            hdActions.issue(workOrder, {
                callback: args => {
                    if (args && args.error) {
                        hdActions.hasActionError = true;
                        cafm.msg.prependMessagePanelTo({
                            element: $('#issueWorkOrderLoader').show(),
                            options: {
                                Type: cafm.enums.MessageType.Error,
                                Title: `${cafm.res.str.TemplateErrorIssuing01.format(cafm.res.str.LabelWorkOrder, workOrder.Reference)}: ${args.error.message}`
                            }
                        });
                    }
                    hdActions.executeIssueMultiple(workOrders, actionIndex);
                },
                'endCallback': hdActions.actionCallback,
                actionIndex: actionIndex
            });
        }
        else {

            if (isMobile)
                $(".winButtons").show().find("[data-key=Cancel]").text(cafm.res.str.TextClose);
            
            delete hdActions.running;
            if (isFunc(hdActions.actionCallback)) {
                hdActions.actionCallback({
                    action: () => {
                        // check if WOs requires printing...
                        let printWorkOrderIds = hdActions.issuing.requiresPrinting(cafm.views.getActionWindowViewModel(), true);
                        if (cafm.util.hasItem(printWorkOrderIds)) {
                            cafm.util.callFunctionAsync({
                                func: () => {
                                    hdActions.showPrint(cafm.util.where(workOrders, wo => {
                                        return cafm.util.exists(printWorkOrderIds, id => id == wo.WorkOrderID);
                                    }))
                                },
                                timeout: 750
                            });
                        }
                        delete hdActions.failedActions;
                    }
                });
                delete hdActions.actionCallback;
            }
        }
    },
    showPlaceOnHold: function (workOrder, endCallback) {
        
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/PlaceOnHold'),
            isForm: false,
            winTitle: cafm.res.str.TitlePlaceWorkOrderOnHold,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 450
            },
            onLoad: function (pnl) {

                var wo = cafm.hd.workOrder;
                    //cs = cafm.getClientSettings();
                    //aadt = cs.helpdeskSettings.autoActionDateTimes,
                    //now = cafm.web.funcs.getCurrentTimeUTC();
                // create view model with ID
                // stamp need not be done here as it's added for all work order actions
                var vm = {
                    WorkOrderID: wo.ID,
                    OnHoldByID: cafm.auth.personId(),
                    OnHoldBy: cafm.auth.personName()
                };

                vm.OnHoldStartDateTime = cafm.web.funcs.getNowUTC();

                // show enforced warning messages if there are any
                cafm.msg.showFormMessages({

                    clientData: wo,
                    messagePropertyName: 'EnforcedWarnings',
                    parent: pnl
                });



                // show or remove the start date field
                if (cafm.isOffline()) {

                    // remove elements that aren't available offline (on hold by/to lookups)
                    $('#onHoldByWrapper').remove();
                    $('#onHoldToWrapper').remove();

                    // fallback to the cached reason code dropdown
                    $('#reasonCodeWrapper').loadView({
                        url: cafm.url.get('Helpdesk/OnHoldReasonCodeDropdown'),
                        onLoad: function () {
                            //Change data-bind from value to dateValue for all datetime picker controls
                            var dtPickers = pnl.find('[data-fieldtype="4"],[data-dtkind="utc"]');
                            dtPickers.each(function (i, item) {
                                let dp = $(item);
                                let bindAttr = dp.data('bind');
                                if (bindAttr) {
                                    dp.data('bind', bindAttr.replace('value', 'dateValue'));
                                }
                            });
                            // setup the form
                            hdActions.helpers.setupActionForm(vm, pnl);
                        }
                    });
                }
                else {
                    
                    // setup the form
                    hdActions.helpers.setupActionForm(vm, pnl);
                }

            }
        });
    },
    /// <field name='placeOnHoldToolbar' type='Object'>On hold toolbar container object</field>
    placeOnHoldToolbar: {
        placeonhold: function () {
            /// <summary>Handler for on hold submit</summary>

            var cs = cafm.getClientSettings();
            var vm = cafm.views.getActionWindowViewModel();
            var rcText;      

            /*session_OnHoldUntilDateTime is not binding correctly for some reason and vm does not show ISO format for the value. Hence following*/
            var hasOnHoldUntil = $('#session_OnHoldUntilDateTime').val() != '';
            if (!hasOnHoldUntil) { vm.OnHoldUntilDateTime = null; }
            if (cafm.isOffline()) {//To limit chances of things going wrong. Server check happens for online mode anyway.
                if (hasOnHoldUntil) {
                    let starts = new Date(vm.OnHoldStartDateTime);
                    let until = new Date(cafm.util.toIsoDateString(vm.OnHoldUntilDateTime));
                    if (starts > until) {
                        $('#actionFormPlc').showMessage({
                            Type: cafm.enums.MessageType.Error,
                            Title: 'The On Hold Until Date cannot be before the On Hold Start Date.'
                        });
                        return false;
                    }
                }
            }

            // get reason code description for offline
            // if we have ReasonCodeDescription then this is a lookup
            if (vm.ReasonCodeDescription) {

                rcText = vm.ReasonCodeDescription;
            }
            // otherwise it's a dropdown
            else {

                var kDdl = $('#onHoldForm select#ReasonCodeID').data().kendoDropDownList;

                if (kDdl) {

                    rcText = kDdl.text();
                }
            }     
                        
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/PlaceOnHold'),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="PlaceOnHold"]',
                loaderText: cafm.res.str.MessagePlacingOnHold,
                values: vm,
                offlineActionType: cafm.enums.OfflineActionType.PlaceOnHold,
                success: function (w) {

                    // end action
                    hdActions.endAction({
                        workOrder: w,
                        refreshForm: true,
                        sigActivity: cafm.enums.SignatureActivity.PlaceOnHold,
                        successMsg: cafm.res.str.MessagePlacingOnHoldComplete
                    });
                },
                fallback: function () {

                    // get the wo and update props
                    var wo = cafm.hd.workOrder;

                    // set on hold props for caching & binding
                    wo.set('OnHoldBy', cafm.auth.personName());
                    wo.set('OnHoldStartDateTime', cafm.util.toIsoDateString(vm.OnHoldStartDateTime));
                    wo.set('OnHoldUntilDateTime', cafm.util.toIsoDateString(vm.OnHoldUntilDateTime));
                    wo.set('OnHoldReason', rcText);
                    wo.set('IsOnHold', true);
                    wo.set('LifeCycleStatus', cafm.enums.LifeCycleStatus.OnHold);

                    // refresh the whole form
                    cafm.hd.refreshWorkOrderForm();

                    // end the offline action (caches work order, refreshes toolbar and closes form)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true
                    });

                    // handle offline signature
                    if (cs.helpdeskSettings.placeOnHoldRequiresSignature) {

                        hdActions.sign({
                            workOrderId: wo.ID,
                            signatureId: cafm.guid.empty,
                            activity: cafm.enums.SignatureActivity.PlaceOnHold
                        });
                    }
                }
            });

        },
        cancel: function () {
            /// <summary>Handler for on hold cancel</summary>

            hdActions.closeActionWindow();
        }
    },
    showTakeOffHold: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/TakeOffHold'),
            isForm: false,
            winTitle: cafm.res.str.TitleTakeWorkOrderOffHold,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 340
            },
            onLoad: function (pnl) {

                var wo = cafm.hd.workOrder;

                //var cs = cafm.getClientSettings();
                //var aadt = cs.helpdeskSettings.autoActionDateTimes;
                //var now = cafm.web.funcs.getEnsuredDateTime({ truncateToMinutes: true });

                // create view model with ID
                // stamp need not be done here as it's added for all work order actions
                var vm = {
                    WorkOrderID: wo.ID
                };        
                
                vm.OnHoldEndDateTime = cafm.web.funcs.getNowUTC();

                // set adjust check boxes
                vm.AdjustResponseDates = wo.OnHoldAdjustResponseDates;
                vm.AdjustFixDates = wo.OnHoldAdjustFixDates;

                // setup the form
                hdActions.helpers.setupActionForm(vm, pnl);
            }
        });
    },
    /// <field name='takeOffHoldToolbar' type='Object'>Off hold toolbar container object</field>
    takeOffHoldToolbar: {
        takeoffhold: function () {
            /// <summary>Handler for off hold submit</summary>

            var cs = cafm.getClientSettings();
            var vm = cafm.views.getActionWindowViewModel();

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/TakeOffHold'),
                elementId: 'offHoldForm',
                loaderSelector: '.winButtons .btn[data-key="TakeOffHold"]',
                loaderText: cafm.res.str.MessageUpdatingOnHold,
                values: vm,
                offlineActionType: cafm.enums.OfflineActionType.TakeOffHold,
                statusCodeFuncs: {
                    200: function (w) {

                        // end action
                        hdActions.endAction({
                            workOrder: w,
                            refreshForm: true,
                            sigActivity: cafm.enums.SignatureActivity.TakeOffHold,
                            successMsg: cafm.res.str.MessageWorkOrderUpdated
                        });
                    }
                },
                fallback: function () {

                    // get the wo and update props
                    var wo = cafm.hd.workOrder;

                    // clear on hold props
                    wo.set('OnHoldStartDateTime', null);
                    wo.set('OnHoldUntilDateTime', null);
                    wo.set('OnHoldEndDateTime', null);
                    wo.set('OnHoldBy', null);
                    wo.set('OnHoldTo', null);
                    wo.set('OnHoldReason', null);
                    wo.set('IsOnHold', false);
                    wo.set('LifeCycleStatus', cafm.enums.LifeCycleStatus.Open);

                    // end the offline action (caches work order, refreshes toolbar and closes form)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true
                    });

                    // handle offline signature
                    if (cs.helpdeskSettings.takeOffHoldRequiresSignature) {

                        hdActions.sign({
                            workOrderId: wo.ID,
                            signatureId: cafm.guid.empty,
                            activity: cafm.enums.SignatureActivity.TakeOffHold
                        });
                    }
                }
            });
        },
        cancel: function () {
            /// <summary>Handler for off hold cancel</summary>

            hdActions.closeActionWindow();
        }
    },
    showExtendOnHold: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/ExtendOnHold'),
            values: workOrder,
            isForm: true,
            winTitle: cafm.res.str.TitleExtendWorkOrderOnHold,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 210
            },
            onLoad: function () {

                var aadt = cafm.getClientSettings().helpdeskSettings.autoActionDateTimes,
                    viewModel = cafm.views.getActionWindowViewModel();

                if (!viewModel.OnHoldUntilDateTime)
                {
                    viewModel.set('OnHoldUntilDateTime', cafm.web.funcs.getNowUTC());
                }
            }
        });
    },
    /// <field name='extendOnHoldToolbar' type='Object'>Extend hold toolbar container object</field>
    extendOnHoldToolbar: {
        extendonhold: function () {
            /// <summary>Handler for extend hold submit</summary>
            var vm = cafm.views.getActionWindowViewModel();          

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/ExtendOnHold'),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="ExtendOnHold"]',
                loaderText: cafm.res.str.MessageExtendingOnHold,
                values: vm,
                statusCodeFuncs: {
                    200: function (w) {
                        
                        // end action
                        hdActions.endAction({
                            workOrder: w,
                            successMsg: cafm.res.str.MessageExtendingOnHoldComplete
                        });
                    }
                }
            });
        },
        cancel: function () {
            /// <summary>Handler for extend hold cancel</summary>

            hdActions.closeActionWindow();
        }
    },
    showResolve: function (workOrder) {
        
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Resolve'),
            isForm: false,
            winTitle: cafm.res.str.TitleResolveWorkOrder,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                width: 900,
                height: 450
            },
            onLoad: hdActions.setupResolveForm
        });
    },
    showResolveMultiple: function (workOrders, endCallback) {

        workOrders = cafm.hd.transformToLightWorkOrders(workOrders);
        
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/ResolveMultiple'),
            values: workOrders,
            isForm: false,
            winTitle: cafm.res.str.TitleResolveWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 450
            },
            onLoad: function (pnl) { hdActions.setupResolveForm(pnl, workOrders); }
        });
    },
    resolveMultiple: function (viewModel) {

        delete hdActions.failedActions;
        delete hdActions.hasActionError;
        delete hdActions.cancelAction;
        hdActions.executeResolveMultiple(viewModel, -1);
    },
    executeResolveMultiple: function (viewModel, actionIndex) {

        // check for cancel flag
        if (hdActions.cancelAction) {
            return;
        }
        actionIndex++;
        if (viewModel.WorkOrders.length > actionIndex) {
            var info = viewModel.WorkOrders[actionIndex];
            viewModel.WorkOrderID = info.WorkOrderID;
            viewModel.LifeCycleStatus = info.LifeCycleStatus;
            viewModel.Reference = info.Reference;
            viewModel.Stamp = info.Stamp;
            hdActions.running = true;
            hdActions.resolve(viewModel, {
                callback: function () {
                    hdActions.executeResolveMultiple(viewModel, actionIndex);
                },
                'endCallback': hdActions.actionCallback
            });
        }
        else {

            if (viewModel.WorkOrders.length > 1)
                cafm.msg.insertMessagePanelBefore({
                    element: $('#resolveForm .msgPnl:first'),
                    options: {
                        Type: cafm.enums.MessageType.Success,
                        Title: cafm.res.str.MessageResolveWorkOrdersComplete
                    }
                });

            delete hdActions.running;

            if (isFunc(hdActions.actionCallback)) {
                hdActions.actionCallback();
                delete hdActions.actionCallback;

                setTimeout(function () {
                    hdActions.closeActionWindow();
                }, hdActions.vars.closeTimeout);
            }
        }
    },
    resolve: function (vm, multiOptions) {
        /// <summary>Resolves a work order</summary>
        /// <param name="vm" type="Object">The resolve work order view model</param>
        /// <param name="multiOptions" type="Object">Multiple action arguments</param>

        var cs = cafm.getClientSettings();
        var multi = isDefined(multiOptions);
        var ref = multi ? vm.Reference : cafm.hd.workOrder.Reference;
        
        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Resolve'),
            elementId: 'actionFormPlc',
            loaderSelector: '.winButtons .btn[data-key="Resolve"]',
            loaderText: cafm.res.str.TemplateResolvingWorkOrder0.format(ref),
            values: vm,
            preventValidationMessage: true,
            keepMessages: true,
            offlineActionType: cafm.enums.OfflineActionType.Resolve,
            statusCodeFuncs: {

                200: function (w) {

                    if (!multi) {

                        // end action
                        hdActions.endAction({
                            workOrder: w,
                            refreshForm: true,
                            sigActivity: cafm.enums.SignatureActivity.Resolve,
                            successMsg: cafm.res.str.TemplateWorkOrder0Resolved.format(ref)
                        });
                    }
                    else {
                        
                        cafm.msg.insertMessagePanelBefore({

                            element: $('#resolveForm .msgPnl:first'),
                            options: {
                                Type: cafm.enums.MessageType.Success,
                                Title: cafm.res.str.TemplateWorkOrder0Resolved.format(ref)
                            }
                        });
                        
                        cafm.util.callFunctionAsync({
                            func: multiOptions.callback,
                            timeout: 2000
                        });
                    }
                },
                500: function () {
                    if (multi) {
                        multiOptions.endCallback();
                    }
                }
            },
            fallback: function () {

                // get the wo and update props
                var wo = cafm.hd.workOrder;

                // set on resolve props for caching & binding
                wo.set('WorkStarted', cafm.util.toIsoDateString(vm.WorkStarted));
                wo.set('WorkFinished', cafm.util.toIsoDateString(vm.WorkFinished));
                wo.set('CompletionDetails', vm.CompletionDetails);
                wo.set('LifeCycleStatus', hdActions.helpers.getResolvedLifeCycleStatus(cs, wo));

                // refresh the whole form
                cafm.hd.refreshWorkOrderForm();

                // end the offline action (caches work order, refreshes toolbar and closes form)
                hdActions.helpers.endOfflineAction({
                    cacheWorkOrder: true
                });

                // handle offline signature
                if (cs.helpdeskSettings.resolveRequiresSignature) {

                    hdActions.sign({
                        workOrderId: wo.ID,
                        signatureId: cafm.guid.empty,
                        activity: cafm.enums.SignatureActivity.Resolve
                    });
                }
            }
        });
    },
    /// <field name='resolveToolbar' type='Object'>Resolve toolbar container object</field>
    resolveToolbar: {
        resolve: function () {
            /// <summary>Submit handler for resolve form</summary>

            // get the work order from the resolve form view model data
            var viewModel = cafm.views.getActionWindowViewModel();

            if (viewModel.isMultiAction) {
                hdActions.resolveMultiple(viewModel);
            }
            else {
                hdActions.resolve(viewModel);
            }

        },
        specifyhours: function(){

            var c = isMobile ? cafm.views.getActionForm() : cafm.views.getActionForm().parents('.k-window:first');

            if (hdActions.validateResolveDetails()) {

                $('button[data-key="SpecifyHours"]', c).hide();
                $('button[data-key="Cancel"]', c).hide();
                $('#resolveFormDefault', c).hide();
                $('#resolveFormHours', c).show();
                $('button[data-key="Resolve"]', c).show();
                $('button[data-key="Back"]', c).show();
            }
        },
        back: function(){

            var c = isMobile ? cafm.views.getActionForm() : cafm.views.getActionForm().parents('.k-window:first');

            $('button[data-key="Resolve"]', c).hide();
            $('button[data-key="Back"]', c).hide();
            $('#resolveFormHours', c).hide();
            $('#resolveFormDefault', c).show();
            $('button[data-key="SpecifyHours"]', c).show();
            $('button[data-key="Cancel"]', c).show();
        },
        cancel: function () {
            /// <summary>Cancel handler for resolve form</summary>
            
            hdActions.closeActionWindow();
        }
    },
    showComplete: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Complete'),
            isForm: false,
            winTitle: cafm.res.str.TitleCompleteWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                width: 900,
                height: 420
            },
            onLoad: hdActions.setupCompleteForm
        });
    },
    showCompleteMultiple: function (workOrders, endCallback) {

        workOrders = cafm.hd.transformToLightWorkOrders(workOrders);
        
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/CompleteMultiple'),
            values: workOrders,
            isForm: false,
            winTitle: cafm.res.str.TitleCompleteWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 450
            },
            onLoad: function (pnl) { hdActions.setupCompleteForm(pnl, workOrders); }
        });
    },
    showPrint: function (workOrders) {

        if (!cafm.util.hasItem(workOrders)) return;
        workOrders = cafm.hd.transformToLightWorkOrders(workOrders);
        let simpleUi = (isMobile || cafm.browsers.isIe() || cafm.browsers.isFirefox());
        let visible = !simpleUi || workOrders.length > 1;
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Print'),
            values: workOrders,
            isForm: false,
            winTitle: workOrders.length < 2 ? `${cafm.res.str.TitlePrintWorkOrder} ${(isMobile ? "" : workOrders[0].Reference)}`.trim() : cafm.res.str.TitlePrintWorkOrders,
            initialText: cafm.res.str.TextPreparingForm,
            visible: visible,
            winOptions: {
                width: simpleUi ? 450 : "80%",
                height: simpleUi ? 450 : "80%"
            }
        });
    },
    completeMultiple: function (viewModel) {

        delete hdActions.failedActions;
        delete hdActions.hasActionError;
        delete hdActions.cancelAction;
        hdActions.executeCompleteMultiple(viewModel, -1);
    },
    executeCompleteMultiple: function (viewModel, actionIndex) {

        // check for cancel flag
        if (hdActions.cancelAction) {
            return;
        }
        actionIndex++;
        if (viewModel.WorkOrders.length > actionIndex) {
            var info = viewModel.WorkOrders[actionIndex];
            viewModel.WorkOrderID = info.WorkOrderID;
            viewModel.LifeCycleStatus = info.LifeCycleStatus;
            viewModel.Reference = info.Reference;
            viewModel.Stamp = info.Stamp;
            hdActions.running = true;
            hdActions.complete(viewModel, {
                callback: function () {
                    hdActions.executeCompleteMultiple(viewModel, actionIndex);
                },
                'endCallback': hdActions.actionCallback
            });
        }
        else {

            if (viewModel.WorkOrders.length > 1)
                cafm.msg.insertMessagePanelBefore({
                    element: $('#completeForm .msgPnl:first'),
                    options: {
                        Type: cafm.enums.MessageType.Success,
                        Title: cafm.res.str.MessageCompleteWorkOrdersComplete
                    }
                });

            delete hdActions.running;

            if (isFunc(hdActions.actionCallback)) {
                hdActions.actionCallback();
                delete hdActions.actionCallback;

                setTimeout(function () {
                    hdActions.closeActionWindow();
                }, hdActions.vars.closeTimeout);
            }
        }
    },
    complete: function (vm, multiOptions) {

        var multi = isDefined(multiOptions);
        var ref = multi ? vm.Reference : cafm.hd.workOrder.Reference;
    
        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Complete'),
            elementId: 'actionFormPlc',
            loaderSelector: '.winButtons .btn[data-key="Complete"]',
            loaderText: cafm.res.str.TemplateCompletingWorkOrder0.format(ref),
            values: vm,
            keepMessages: true,
            offlineActionType: cafm.enums.OfflineActionType.Complete,
            statusCodeFuncs: {
                200: function (w) {

                    if (!multi) {

                        // end action
                        hdActions.endAction({
                            workOrder: w,
                            refreshForm: true,
                            successMsg: cafm.res.str.TemplateWorkOrder0Completed.format(ref)
                        });
                    }
                    else {

                        cafm.msg.insertMessagePanelBefore({

                            element: $('#completeForm .msgPnl:first'),
                            options: {
                                Type: cafm.enums.MessageType.Success,
                                Title: cafm.res.str.TemplateWorkOrder0Completed.format(ref)
                            }
                        });
                        
                        cafm.util.callFunctionAsync({
                            func: multiOptions.callback,
                            timeout: 2000
                        });
                    }
                },
                500: function () {
                    if (multi) {
                        multiOptions.endCallback();
                    }
                }
            },
            fallback: function () {

                // get the wo and update props
                var wo = cafm.hd.workOrder;

                // set on hold props for caching & binding
                wo.set('WorkStarted', cafm.util.toIsoDateString(vm.WorkStarted));
                wo.set('WorkFinished', cafm.util.toIsoDateString(vm.WorkFinished));
                wo.set('CompletionDetails', vm.CompletionDetails);
                wo.set('LifeCycleStatus', cafm.enums.LifeCycleStatus.Completed);

                // refresh the whole form
                cafm.hd.refreshWorkOrderForm();

                // end the offline action (caches work order, refreshes toolbar and closes form)
                hdActions.helpers.endOfflineAction({
                    cacheWorkOrder: true
                });
            }
        });
    },
    /// <field name='completeToolbar' type='Object'>Complete toolbar container object</field>
    completeToolbar: {
        complete: function () {
            /// <summary>Submit handler for complete form</summary>

            var viewModel = cafm.views.getActionWindowViewModel();

            if (viewModel.isMultiAction) {
                hdActions.completeMultiple(viewModel);
            }
            else {
                hdActions.complete(viewModel);
            }
        },
        cancel: function () {
            /// <summary>Cancel handler for complete form</summary>

            hdActions.closeActionWindow();
        }
    },
    showDiscard: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Discard'),
            values: workOrder,
            isForm: true,
            winTitle: cafm.res.str.TitleDiscardWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 360
            },
            onLoad: function () {
                var viewModel = cafm.views.getActionWindowViewModel();
                viewModel.set('DiscardDateTime', cafm.web.funcs.getSessionDateTimeNow());
                $('#discardForm').show();
            }
        });
    },
    /// <field name='discardToolbar' type='Object'>Discard toolbar container object</field>
    discardToolbar: {
        discard: function () {
            /// <summary>Submit handler for discard form</summary>

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/Discard'),
                elementId: 'actionFormPlc',
                loaderSelector: '.winButtons .btn[data-key="Discard"]',
                loaderText: cafm.res.str.MessageDiscardingWorkOrder,
                values: cafm.views.getActionWindowViewModel(),
                statusCodeFuncs: {

                    200: function (w) {

                        // end action
                        hdActions.endAction({
                            workOrder: w,
                            refreshForm: true,
                            successMsg: cafm.res.str.MessageDiscardingWorkOrderComplete
                        });
                    }
                }
            });
        },
        cancel: function () {
            /// <summary>Cancel handler for discard form</summary>

            hdActions.closeActionWindow();
        }
    },
    showAccept: function (workOrder, endCallback) {

        var wo = workOrder;
        var woLight = cafm.hd.transformToLightWorkOrder(workOrder);
       

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Accept'),
            values: woLight,
            isForm: true,
            winTitle: cafm.res.str.TitleAcceptWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 300
            },
            onLoad: function (pnl)
            {
                var clFail = wo.WillFailedChecklistsPreventAccept;
                var clIncomp = wo.WillUnansweredChecklistsPreventAccept;
                var woSch = wo.IsSchedulableType;

                if (!woSch || (clFail || clIncomp))
                {
                    $('.staticMsgPnl').remove();
                    $('.cfField').remove();
                }

                if (clFail || clIncomp)
                {
                    $('.winButtons').find('.btn[data-key="Accept"]').prop('disabled', true);
                }

                if (!woSch && !((clFail || clIncomp)))
                {
                    $('.winButtons').remove();
                } else
                {
                    $('.winButtons').setupToolbar();
                }

                // check for failed checklists or incomplete mandatory checklists
                if (clFail || clIncomp) {
                    if (clFail) {
                        pnl.showMessage({
                            Type: cafm.enums.MessageType.Error,
                            Title: wo.AcceptFailureMessageDueToFailedChecklist
                        });
                    }
                    else if (clIncomp) {
                        pnl.showMessage({
                            Type: cafm.enums.MessageType.Error,
                            Title: wo.AcceptFailureMessageDueToIncompleteChecklist
                        });
                    }
                    return;
                }
            }
        });
    },
    showAcceptForm: function () {

        $('#acceptFormPlc').show();
    },
    accept: function (viewModel) {
        /// <summary>Accepts the work order</summary>
        /// <param name="viewModel" type="Object">the view model</param>


        var wo = cafm.hd.workOrder;

        if (wo.WillFailedChecklistsPreventAccept || wo.WillUnansweredChecklistsPreventAccept) {
            return; //Show message in showAccept
        };


        // is it auto accept
        var aa = viewModel.OnFormLoad == 'accept';

        // set to current datetime
        viewModel.ActualResponseDateTime = cafm.web.funcs.getNowUTC();

        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Accept'),
            elementId: 'actionFormPlc',
            loaderSelector: aa ? '#actionFormPlc' : '.winButtons .btn[data-key="Accept"]',
            loaderText: cafm.res.str.MessageAcceptingWorkOrder,
            executeDelay: aa,
            values: viewModel,
            preventValidate: aa, // no need to validate as this is accepting on load without the schedule form
            statusCodeFuncs: {
                200: function (w) {

                    // end action
                    hdActions.endAction({
                        workOrder: w,
                        refreshForm: true,
                        successMsg: cafm.res.str.MessageAcceptingWorkOrderComplete
                    });
                }
            }
        });
    },
    assign: function (viewModel) {
        /// <summary>Assigns the work order</summary>
        /// <param name="viewModel" type="Object">the view model</param>

        var wo = cafm.hd.workOrder;
       
        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Assign'),
            elementId: 'actionFormPlc',
            loaderSelector: '#actionFormPlc',
            loaderText: cafm.res.str.MessageAcceptingWorkOrder,
            values: cafm.util.createParentChildId(viewModel.ParentID, viewModel.ChildID),
            executeDelay: true,
            preventValidate: true,
            statusCodeFuncs: {
                200: function (w) {

                    // end action
                    hdActions.endAction({
                        workOrder: w,
                        refreshForm: true,
                        successMsg: cafm.res.str.MessageAcceptingWorkOrderComplete
                    });
                }
            }
        });
    },
    /// <field name='acceptToolbar' type='Object'>Accept toolbar container object</field>
    acceptToolbar: {
        accept: function () {
            /// <summary>Submit handler for accept form</summary>

            hdActions.accept(cafm.views.getActionWindowViewModel());
        },
        cancel: function () {
            /// <summary>Cancel handler for accept form</summary>

            hdActions.closeActionWindow();
        }
    },
    showDecline: function (workOrder, endCallback) {

        workOrder = cafm.hd.transformToLightWorkOrder(workOrder);

        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Decline'),
            values: workOrder,
            isForm: true,
            winTitle: cafm.res.str.MessageDecliningWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 160
            }
        });
    },
    decline: function (vm) {
        /// <summary>Declines the work order</summary>
        /// <param name="vm" type="Object">the view model</param>

        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Decline'),
            elementId: 'actionFormPlc',
            loaderSelector: '#actionFormPlc',
            loaderText: cafm.res.str.MessageDecliningWorkOrder,
            values: vm,
            executeDelay: true,
            statusCodeFuncs: {
                200: function (w) {

                    // end action
                    hdActions.endAction({
                        workOrder: w,
                        refreshForm: true,
                        successMsg: cafm.res.str.MessageDecliningWorkOrderComplete
                    });
                }
            }
        });
    },
    showStart: function (endCallback) {
        /// <summary>Show start work order action</summary>
        /// <param name="endCallback" type="Function">Callback function</param>
        
        hdActions.openActionWindow({
            url: cafm.url.get('Helpdesk/Start'),
            isForm: false,
            winTitle: cafm.res.str.TitleStartWorkOrder,
            callback: endCallback,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: {
                height: 300
            },
            onLoad: function (pnl) {

                var wo = cafm.hd.workOrder;
                var cs = cafm.getClientSettings();
                var aadt = cs.helpdeskSettings.autoActionDateTimes;
                var bcr = cs.helpdeskSettings.ensureAssetBarcodeIsMatched && wo.HasAssetWithBarcode;
                var raip = wo.RiskAssessmentIsPending;

                // check for failed checklists or incomplete mandatory checklists
                if (wo.WillFailedChecklistsPreventStart || wo.WillUnansweredChecklistsPreventStart) {

                    //TODO:Please review
                    //$('#startForm').find(".staticMsgPnl").remove();

                    if (wo.WillFailedChecklistsPreventStart) {
                        pnl.showMessage({
                            Type: cafm.enums.MessageType.Error,
                            Title: wo.StartFailureMessageDueToFailedChecklist
                        });

                    }
                    else if (wo.WillUnansweredChecklistsPreventStart) {
                        pnl.showMessage({
                            Type: cafm.enums.MessageType.Error,
                            Title: wo.StartFailureMessageDueToIncompleteChecklist
                        });
                    }

                    $('#staticMsgPnl ').hide();

                    // disable Start button
                    $('.winButtons').find('.btn[data-key="Start"]').prop('disabled', true);

                    // setup the toolbar
                    $('.winButtons').setupToolbar();
                    return;
                }

                // create view model with ID, InternalRequiredResponseDateTime, WorkStarted
                // stamp need not be done here as it's added for all work order actions
                var vm = {
                    WorkOrderID: wo.ID,
                    InternalRequiredResponseDateTime: wo.InternalRequiredResponseDateTime,
                    WorkStarted: cafm.web.funcs.getNowUTC() 
                };

                // show or remove the start date field
                if (aadt) {

                    $('#startDateWrapper').remove();
                }
                else {

                    $('#startDateWrapper').show();
                }

                // show or remove the barcode field if required
                if (bcr) {

                    $('#barcodeWrapper').show();
                }
                else {

                    $('#barcodeWrapper').remove();
                }

                // show or remove the risk assessment field if required
                if (raip) {

                    $('#riskAssessmentWrapper').show();
                }
                else {

                    $('#riskAssessmentWrapper').remove();
                }

                vm.InputRequired =
                    !aadt || // required if not auto action date/times
                    raip || // required if risk assessment checkbox is pending
                    bcr; // required if barcode is required
                
                // setup the form
                hdActions.helpers.setupActionForm(vm, pnl);
                
                // if no input is required automagically start the work order
                if (!vm.InputRequired) {

                    // hide start form instructions
                    pnl.find('.staticMsgPnl').hide();

                    // click the start button
                    $('.winButtons button[data-key="Start"]').hide().click();

                    // hide the cancel button
                    $('button[data-key="Cancel"]').hide();
                }
            },
            onWindowClose: function () {

                // check for labour charge start handler, the window was closed so tidy up by calling the handler
                if (cafm.handlers.exists(cafm.hd.lc.startOnWorkOrderStartHandlerName)) {

                    cafm.handlers.exe(cafm.hd.lc.startOnWorkOrderStartHandlerName);
                }
            }
        });
    },
    /// <field name='startToolbar' type='Object'>Start toolbar container object</field>
    startToolbar: {

        start: function () {
            /// <summary>Submit handler for start form</summary>
            var cs = cafm.getClientSettings(), vm = cafm.views.getActionWindowViewModel();

            var wo = cafm.hd.workOrder;
        
            var startWorker = function (hs, dto) {

                var ls;


                if (dto.StartLabourChargeData) {

                    ls = '.winButtons .btn[data-key="StartLabourCharge"]';
                }
                else if (dto.InputRequired) {

                    ls = '.winButtons .btn[data-key="Start"]';
                }
                else {

                    ls = '#actionFormPlc';
                }

                cafm.actions.execute({
                    url: cafm.url.api('WorkOrder/Start'),
                    elementId: 'actionFormPlc',
                    loaderSelector: ls,
                    loaderText: cafm.res.str.MessageStartingWorkOrder,
                    offlineActionType: cafm.enums.OfflineActionType.Start,
                    values: dto,
                    executeDelay: dto.InputRequired,
                    statusCodeFuncs: {
                        200: function (w) {

                            // end action
                            hdActions.endAction({
                                workOrder: w,
                                refreshForm: true,
                                sigActivity: cafm.enums.SignatureActivity.Start,
                                successMsg: cafm.res.str.MessageStartingWorkOrderComplete
                            });
                        }
                    },
                    fallback: function () {

                        // get the wo and update props
                        var wo = cafm.hd.workOrder;
                        wo.set('WorkStarted', cafm.util.toIsoDateString(dto.WorkStarted));

                        if (isDefined(dto.RiskAssessmentHasBeenCarriedOut)) {

                            wo.set('RiskAssessmentHasBeenCarriedOut', dto.RiskAssessmentHasBeenCarriedOut);
                        }

                        // refresh the whole form
                        cafm.hd.refreshWorkOrderForm();

                        // handle offline start labour charge
                        if (dto.StartLabourChargeData) {

                            cafm.hd.lc.handlers.start.startLabourChargeOffline(dto.StartLabourChargeData);
                        }
                        else {

                            // end the offline action (caches work order, refreshes toolbar and closes form)
                            hdActions.helpers.endOfflineAction({
                                cacheWorkOrder: true
                            });
                        }

                        // handle offline signature
                        if (hs.startRequiresSignature) {

                            hdActions.sign({
                                workOrderId: wo.ID,
                                signatureId: cafm.guid.empty,
                                activity: cafm.enums.SignatureActivity.Start
                            });
                        }
                    }
                });
            }

            // check if the user should be prompted to start a labour charge
            if (cafm.hd.helpers.isAnyEngineer() && 
                cs.helpdeskSettings.labourChargesMode == cafm.enums.LabourChargesMode.StartEndRealTimeRecording &&
                cafm.hd.helpers.isPrincipalOrAssistantForWorkOrder(cafm.hd.workOrder) &&
                !cafm.hd.lc.helpers.hasInProgressLabourChargeForPerson(cafm.auth.personId())) {

                // validate the start form
                if (cafm.views.getActionForm().validateElement()) {

                    // show yes / no prompt to start labour charge
                    cafm.util.yesNoDialogue({

                        message: cafm.res.str.MessageStartLabourCharge,
                        yesHandler: function () {

                            // setup the start labour charge handler so it actually calls back to the startWorker passing the labour charge dto
                            cafm.handlers.set(cafm.hd.lc.startOnWorkOrderStartHandlerName, function (startLabourCharge) {
                                
                                try {

                                    if (startLabourCharge) {

                                        vm.StartLabourChargeData = startLabourCharge;
                                    }

                                    // start the wo
                                    startWorker(cs.helpdeskSettings, vm);
                                }
                                finally {

                                    // remove once done
                                    cafm.handlers.remove(cafm.hd.lc.startOnWorkOrderStartHandlerName);
                                }

                            });

                            cafm.hd.lc.helpers.showStartLabourCharge({

                                formContainer: $('#actionFormPlc')
                            });
                        },
                        noHandler: function () {

                            // start the wo
                            startWorker(cs.helpdeskSettings, vm);
                        }
                    })
                }
            }
            else {

                // start the wo
                startWorker(cs.helpdeskSettings, vm);
            }
            
        },
        cancel: function () {
            /// <summary>Cancel handler for accept form</summary>

            hdActions.closeActionWindow();
        }
    },
    openActionWindow: function (o) {
        /// <summary>Open work order action window helper used by work order actions</summary>
        /// <param name="o" type="Object">Open action window options object</param>

        cafm.views.openActionWindow(o);

        if (o.callback) {
            hdActions.actionCallback = o.callback;
        }
    },
    closeActionWindow: function (refreshNav) {
        /// <summary>Close work order action window helper used by work order actions</summary>
        /// <param name="refreshNav" type="Boolean">Flag for refreshing navigation and toolbar</param>

        cafm.views.closeActionWindow();
        if (refreshNav) {
            cafm.hd.refreshNavigation();
        }
    },
    endAction: function (args) {
        /// <summary>Ends an online work order action</summary>
        /// <param name="args" type="Object">Options object containing following options: workOrder = work order to set on main form (work order object), successMsg = message option to show (string), refreshView = option to refresh the whole work order view (boolean), refreshForm = option to refresh the work order form (boolean), refreshMenu = option to refresh the work order menu and actions toolbar (boolean) - will be ignored if refreshFrom is true</param>

        // no args - go no further
        if (!args) return;

        var w = args.workOrder,
            hasWorkOrder = !isNullOrUndefined(w) && cafm.util.guidHasValue(w.ID);

        if (cafm.util.hasStringVal(args.successMsg)) {

            // show success message
            $('#actionFormPlc').showMessage({
                Type: cafm.enums.MessageType.Success,
                Title: args.successMsg
            });
        }

        if (hasWorkOrder) {

            // rebind the work order
            cafm.hd.setWorkOrder(w, true);
        }

        if (args.refreshView) {

            // refresh the view
            cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskEditWorkOrder, {
                workOrderId: cafm.hd.workOrder.ID
            });

        }

        if (args.refreshForm) {
            
            // refresh the whole form
            cafm.hd.refreshWorkOrderForm();
        }

        setTimeout(function () {

            // close window and ensure refreshMenu is a boolean
            if(!args.preventCloseActionWindow)
                hdActions.closeActionWindow(args.refreshMenu === true);

            if (hasWorkOrder && args.sigActivity) {

                // sign the work order if applicable
                hdActions.sign({
                    workOrderId: w.ID,
                    signatureId: w.RequiredSignatureId,
                    activity: args.sigActivity
                });
            }

            // handle any callback
            cafm.util.callFunction(args.callback);

        }, hdActions.vars.closeTimeout);
    },
    sign: function (args) {
        /// <summary>Opens the sign work order window</summary>
        /// <param name="args" type="Boolean">Options object for cafm.sig.signWorkOrder</param>
        
        if (args.signatureId) {

            setTimeout(function () {

                args.onSigned = hdActions.onSigned;
                cafm.sig.signWorkOrder(args);
            }, 500);
        }
    },
    onSigned: function (wo) {
        /// <summary>Handler for after a signature has been submitted - refreshes the work order</summary>
        /// <param name="refreshNav" type="Boolean">Flag for refreshing navigation and toolbar</param>
        
        // update the client wo
        cafm.hd.setWorkOrder(wo, true);

        // refresh the whole work order form - this is important as signature can change the status of the work order
        cafm.hd.refreshWorkOrderForm()
    },
    setupResolveForm: function (pnl, wos) {
        /// <summary>Setup the resolve form</summary>
        /// <param name="pnl" type="$">Form element</param>
        /// <param name="wos" type="Array">Optional collection of work orders to resolve - main form work order used otherwise</param>

        // get view model
        var vm = cafm.views.getActionWindowViewModel(),
            wo = isArray(wos) ? {} : cafm.hd.workOrder,
            cs = cafm.getClientSettings(),
            hs = cs.helpdeskSettings,
            aadt = hs.autoActionDateTimes,
            bcr = hs.ensureAssetBarcodeIsMatched && wo.HasAssetWithBarcode && !vm.isMultiAction,
            cih = hs.canInputHoursWorked && cafm.hd.helpers.isTradePersonForWorkOrder(wo),
            aho = hs.allowHoursOverride,
            aro = hs.allowOverrideChargeRate,
            cr;

        // check for failed checklists or incomplete mandatory checklists
        if (wo.WillFailedChecklistsPreventResolveOrComplete || wo.WillUnansweredChecklistsPreventResolveOrComplete) {


            if (wo.WillFailedChecklistsPreventResolveOrComplete) {
                // show cannot resolve message
                pnl.showMessage({
                    Type: cafm.enums.MessageType.Error,
                    Title: wo.ResolveFailureMessageDueToFailedChecklist
                });
            }
            else if (wo.WillUnansweredChecklistsPreventResolveOrComplete) {
                // show cannot resolve message
                pnl.showMessage({
                    Type: cafm.enums.MessageType.Error,
                    Title: wo.ResolveFailureMessageDueToIncompleteChecklist
                });
            }

            // hide the form fields
            pnl.find('#resolveFormDefault').hide();

            // disable resolve and specify hours buttons as input is useless in this situation
            $('.winButtons').find('.btn[data-key="SpecifyHours"],.btn[data-key="Resolve"]').prop('disabled', true);

            // setup the toolbar
            $('.winButtons').setupToolbar();

            return;
        }

        // auto set resolved date time always
        vm.ResolvedDateTime = cafm.web.funcs.getNowUTC(); 

        // stamp need not be done here as it's added for all work order actions
        if (isArray(wos)) {

            vm.WorkOrders = wos;
            vm.WorkOrderID = wos[0].WorkOrderID;
        }
        else {

            vm.WorkOrderID = wo.ID;
        }

        // if configured with auto date times then hide the resolved date time control
        var adt = $('#actionDateTimeWrapper');
        if (aadt) {

            adt.remove();
        }
        else {

            adt.show();
        }

        // auto set or prepopulate work started date time
        if (aadt && !wo.WorkStarted) {
            vm.WorkStarted = cafm.web.funcs.getNowUTC();
        }       
        else if (wo.WorkStarted) {
            vm.WorkStarted = wo.WorkStarted;
        }

        // auto set or prepopulate work finished date time
        if (aadt && !wo.WorkFinished) {
            vm.WorkFinished = cafm.web.funcs.getNowUTC(); 
        }
        else if (wo.WorkFinished) {
            vm.WorkFinished = wo.WorkFinished;
        }              

        var sdt = $('#startDateTimeWrapper');
        if (aadt && vm.WorkStarted) {

            sdt.remove();
        }
        else {

            sdt.show();
        }
        

        var fdt = $('#finishDateTimeWrapper');
        if (aadt && vm.WorkFinished) {

            fdt.remove();
        }
        else {

            fdt.show();
        }

        // show or remove the barcode field
        var bcw = $('#barcodeWrapper');
        if (bcr) {

            bcw.show();
        }
        else {

            bcw.remove();
        }

        // remove the estimated cost if this is a multiple action
        if (vm.isMultiAction) {
            
            $('#estCostWrapper').remove();
        }

        // set person name
        vm.TradePerson = cafm.auth.personName();

        // set est cost
        vm.EstimatedCost = kendo.toString(wo.EstimatedCost, 'c');

        // show enforced warning messages if there are any
        cafm.msg.showFormMessages({

            clientData: wo,
            messagePropertyName: 'EnforcedWarnings',
            parent: pnl
        });

        var applyHoursEvents = function (offline) {

            var ha = hdActions;
            var bh = $('[name="HourCharges_BasicHours"]').data('kendoNumericTextBox');
            var bm = $('[name="HourCharges_BasicMinutes"]').data('kendoNumericTextBox');
            var oh = $('[name="HourCharges_OvertimeHours"]').data('kendoNumericTextBox');
            var om = $('[name="HourCharges_OvertimeMinutes"]').data('kendoNumericTextBox');

            bh.bind('change', ha.onResolveHoursFieldChanged);
            bh.bind('spin', ha.onResolveHoursFieldChanged);
            bm.bind('change', ha.onResolveHoursFieldChanged);
            bm.bind('spin', ha.onResolveHoursFieldChanged);
            oh.bind('change', ha.onResolveHoursFieldChanged);
            oh.bind('spin', ha.onResolveHoursFieldChanged);
            om.bind('change', ha.onResolveHoursFieldChanged);
            om.bind('spin', ha.onResolveHoursFieldChanged);
            
            // bind the work finished event on the vm for a consistent approach to desktop/mobile 
            vm.bind('set', function (e) {

                if (e.field == 'WorkFinished') {

                    setTimeout(function () {

                        ha.onResolveFinishChanged();
                    }, 200);
                }
            });

            if (aho || offline) {

                bh.enable(true);
                bm.enable(true);
            }
            else {

                bh.enable(false);
                bm.enable(false);
            }

            hdActions.resolveOvertimeRateElement = $('[name="HourCharges_OvertimeRateCodeID"]');
        }

        // show or remove the start date field
        if (cafm.isOffline()) {

            var fallbacks = 0;
            var lookupFallback = function (selector, path, disableDropdown) {

                // fallback to the cached reason code dropdown
                $(selector).loadView({
                    url: cafm.url.get(path),
                    onLoad: function (fPnl) {

                        // disable dropdown if flag is true
                        if (disableDropdown) {

                            fPnl.find('select.cfControl').attr('disabled', true);
                        }

                        fallbacks++;
                        if (fallbacks == (cih ? 3 : 1)) {

                            // setup the form
                            hdActions.helpers.setupActionForm(vm, pnl, function (vm) {

                                if (cih) {

                                    applyHoursEvents(true);
                                }
                                else {

                                    $('button[data-key="Resolve"]').show();
                                }
                            });
                        }
                    }
                });
            }
            lookupFallback('#resolutionCodeWrapper', 'Helpdesk/ResolutionCodeDropdown');

            if (cih) {

                vm.set('HourCharges', {

                    BasicHours: 0,
                    BasicMinutes: 0
                });

                if (cr) {

                    vm.set('HourCharges.ChargeRateCodeID', cr.ID);
                    vm.set('HourCharges.ChargeRateCodeDescription', cr.Description);
                }
                
                vm.set('TotalTime', '0:00');
                vm.set('TimeWorkedMillis', 0);

                lookupFallback('#chargeRateWrapper', 'Helpdesk/ResolveChargeRateDropdown', !aro && cr && cafm.util.guidHasValue(cr.ID));
                lookupFallback('#overtimeRateWrapper', 'Helpdesk/ResolveOvertimeRateDropdown');
            }
        }
        else {

            // setup the form
            hdActions.helpers.setupActionForm(vm, pnl, function (vm) {
                
                // if user can input hours then set charge rate
                if (cih && !vm.isMultiAction) {

                    cr = cafm.hd.helpers.getDefaultChargeRate(wo);                    
                    if (!aro && cr && cafm.util.guidHasValue(cr.ID)) {

                        pnl.find('#chargeRateWrapper').disableLookup();
                    }
                }

                if (cih) {

                    applyHoursEvents();

                    // set hours worked and pass through default charge rate code if there is one
                    hdActions.helpers.setResolveHoursWorked(vm, cr);
                }
                else {

                    $('#resolveFormHours').remove();
                    $('button[data-key="SpecifyHours"]').remove();
                    $('button[data-key="Resolve"]').show();
                }                 
            });
        }
    },
    setupCompleteForm: function (pnl, wos) {
        /// <summary>Setup the complete form</summary>
        /// <param name="pnl" type="$">Form element</param>
        /// <param name="wos" type="Array">Optional collection of work orders to complete - main form work order used otherwise</param>

        var wo = isArray(wos) ? {} : cafm.hd.workOrder,
            cs = cafm.getClientSettings(),
            aadt = cs.helpdeskSettings.autoActionDateTimes,
            vm = cafm.views.getActionWindowViewModel();

        // check for failed checklists or incomplete mandatory checklists
        if (wo.WillFailedChecklistsPreventResolveOrComplete || wo.WillUnansweredChecklistsPreventResolveOrComplete) {

            // show cannot complete message
            if (wo.WillFailedChecklistsPreventResolveOrComplete) {
                // show cannot resolve message
                pnl.showMessage({
                    Type: cafm.enums.MessageType.Error,
                    Title: wo.CompleteFailureMessageDueToFailedChecklist
                });
            } else if (wo.WillUnansweredChecklistsPreventResolveOrComplete) {
                // show cannot resolve message
                pnl.showMessage({
                    Type: cafm.enums.MessageType.Error,
                    Title: wo.CompleteFailureMessageDueToIncompleteChecklist
                });
            }

            // hide the form fields
            pnl.find('#completeFormInput').hide();

            // disable complete button as input is useless in this situation
            $('.winButtons').find('.btn[data-key="Complete"]').prop('disabled', true);

            // setup the toolbar
            $('.winButtons').setupToolbar();

            return;
        }

        // auto set work completed always
        vm.WorkCompleted = cafm.web.funcs.getNowUTC();

        // stamp need not be done here as it's added for all work order actions
        if (isArray(wos)) {

            vm.WorkOrders = wos;
            vm.WorkOrderID = wos[0].WorkOrderID;
        }
        else {

            vm.WorkOrderID = wo.ID;
        }
        
        // if configured with auto action date times then hide work completed
        var adt = $('#actionDateTimeWrapper');
        if (aadt) {

            adt.remove();
        }
        else {
                    
            adt.show();
        }

        // auto set or prepopulate work started date time
        if (aadt && !wo.WorkStarted) {
            vm.WorkStarted = cafm.web.funcs.getNowUTC();
        }
        else if (wo.WorkStarted) {
            vm.WorkStarted = wo.WorkStarted;
        }

        // auto set or prepopulate work finished date time
        if (aadt && !wo.WorkFinished) {
            vm.WorkFinished = cafm.web.funcs.getNowUTC();
        }
        else if (wo.WorkFinished) {
            //TODO: Why we should ever be here?
            vm.WorkFinished = wo.WorkFinished;
        }    
      
        var sdt = $('#startDateTimeWrapper');
        if (aadt && vm.WorkStarted) {

            sdt.remove();
        }
        else {

            sdt.show();
        }

        var fdt = $('#finishDateTimeWrapper');
        if (aadt && vm.WorkFinished) {

            fdt.remove();
        }
        else {

            fdt.show();
        }

        // set person name
        vm.TradePerson = cafm.auth.personName();

        // show enforced warning messages if there are any
        cafm.msg.showFormMessages({

            clientData: wo,
            messagePropertyName: 'EnforcedWarnings',
            parent: pnl
        });

        // show or remove the start date field
        if (cafm.isOffline()) {
                    
            // fallback to the cached reason code dropdown
            $('#resolutionCodeWrapper').loadView({
                url: cafm.url.get('Helpdesk/ResolutionCodeDropdown'),
                onLoad: function () {

                    // setup the form
                    hdActions.helpers.setupActionForm(vm, pnl);
                }
            });
        }
        else {

            // setup the form
            hdActions.helpers.setupActionForm(vm, pnl);
        }
    },
    onResolveHoursFieldChanged: function () {
        /// <summary>Handler for resolve labour hours field changed event</summary>

        var vm = cafm.views.getActionWindowViewModel(),
            fieldName = this.element.attr('name');

        vm.set(fieldName, this.value());

        var aho = cafm.getClientSettings().helpdeskSettings.allowHoursOverride,
            ut = cafm.util,
            hs = vm.get('HourCharges'),
            bh = ut.num(hs.get('BasicHours')) * 60,
            bm = ut.num(hs.get('BasicMinutes')),
            oh = ut.num(hs.get('OvertimeHours')) * 60,
            om = ut.num(hs.get('OvertimeMinutes')),
            totalMillis = vm.get('TimeWorkedMillis'),
            totalMinutes;

        // if change is basic hours / mins
        if (fieldName.indexOf('HourCharges_Basic') == 0) {
            
            totalMinutes = oh + om;

            if (bh > 0) {

                totalMinutes += bh;
            }

            if (bm > 0) {

                totalMinutes += bm;
            }
        }
        else {
            
            if (aho) {

                // start with basic
                totalMinutes = bh + bm;

                // add overtime
                if (oh > 0) {

                    totalMinutes += oh;
                }
                if (om > 0) {

                    totalMinutes += om;
                }
            }
            else {

                // current total minutes
                totalMinutes = totalMillis / 60000;

                // check overtime doesn't exceed the basic
                var overtimeMinutes = oh + om, nbm, nbh;
                if (overtimeMinutes > totalMinutes) {

                    // reset applicable field
                    if (fieldName == 'HourCharges_OvertimeHours') {

                        hs.set('OvertimeHours', 0);
                    }
                    else {

                        hs.set('OvertimeMinutes', 0);
                    }

                    // calculate new basic
                    nbm = totalMinutes % 60;
                    nbh = totalMinutes >= 60 ? parseInt(totalMinutes / 60) : 0;

                    // reset basic
                    hs.set('BasicHours', nbh);
                    hs.set('BasicMinutes', nbm);
                }
                else {

                    // take away overtime from basic
                    var basicMinutes = totalMinutes - oh - om;

                    // calculate new basic
                    nbm = basicMinutes % 60,
                    nbh = basicMinutes >= 60 ? parseInt(basicMinutes / 60) : 0;

                    // reset basic
                    hs.set('BasicHours', nbh);
                    hs.set('BasicMinutes', nbm);
                }
            }
        }
        
        // set total millis
        totalMillis = totalMinutes * 60000;
        vm.set('TimeWorkedMillis', totalMillis);

        var totalHours = totalMinutes >= 60 ? parseInt(totalMinutes / 60) : 0,
            remMinutes = totalMinutes % 60,
            timeStr = '{0} : {1}'.format(totalHours, kendo.toString(remMinutes, '00')),
            otEl = hdActions.resolveOvertimeRateElement;

        // set total time string
        vm.set('TotalTime', timeStr);

        // if there is overtime make overtime rate mandatory
        if (oh > 0 || om > 0)
        {
            otEl.attr('required', true);
        }
        else
        {
            otEl.removeAttr('required');
        }
    },
    onResolveFinishChanged: function () {
        /// <summary>Handler for resolve finish date changed</summary>

        var vm = cafm.views.getActionWindowViewModel();

        if (vm.get('WorkFinished')) {

            hdActions.helpers.setResolveHoursWorked(vm);
        }
    },
    validateResolveDetails: function () {
        /// <summary>Validates resolve form</summary>
        /// <returns type="Boolean">True if valid</returns>

        var v = $('#resolveFormDefault').kendoValidator().data("kendoValidator");
        cafm.kendo.ext.validator.modify(v);
        return v && v.validate(); 
    },
    endTask: function (workOrder) {
        /// <summary>Execute end task action</summary>
        /// <param name="workOrder" type="Object">The work order client object</param>

        var endTaskFunc = function (showLabChas) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/EndTask'),
                elementId: cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#centreCol',
                loaderText: cafm.res.str.MessageEndingTask,
                values: cafm.util.createParentChildId(workOrder.ID, cafm.auth.personId()),
                statusCodeFuncs: {
                    200: function (w) {

                        // rebind the work order
                        cafm.hd.setWorkOrder(w, true);

                        if (showLabChas) {

                            // refresh the whole form
                            cafm.hd.refreshWorkOrderForm();

                            // show the labour charge form
                            cafm.hd.lc.helpers.showAddLabourCharge({ isEndTask: true });
                        }
                        else {

                            cafm.hd.onEndWorkOrderEdit();
                        }
                    }
                }
            });
            return false;
        };

        var hs = cafm.getClientSettings().helpdeskSettings,
            lcm = cafm.enums.LabourChargesMode;

        if (workOrder.WorkStarted != null && cafm.enums.isSingleEnumValue(hs.labourChargesMode, [lcm.Adhoc, lcm.OnResolveAutomaticEditableHours, lcm.OnResolveAutomaticFixedHours])) {

            cafm.util.yesNoDialogue({

                message: cafm.res.str.MessageAddLabourChargesToWo,
                yesHandler: function () {

                    endTaskFunc(true);
                    return false;
                },
                noHandler: function () { endTaskFunc(false); }
            });
        }
        else {

            endTaskFunc(false);
        }
    },
    resetStatus: function (workOrder) {
        /// <summary>Reset status action</summary>
        /// <param name="workOrder" type="Object">The work order client object</param>

        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/ResetStatus'),
            elementId: cafm.res.consts.ElementId_MainForm,
            loaderSelector: '#centreCol',
            values: {
                ID: workOrder.ID
            },
            statusCodeFuncs: {
                200: function (w) {

                    // rebind the work order
                    cafm.hd.setWorkOrder(w, true);

                    // refresh the whole form
                    cafm.hd.refreshWorkOrderForm();
                }
            }
        });
    },
    unlock: function (workOrder) {
        /// <summary>Execute unlock action</summary>
        /// <param name="workOrder" type="Object">The work order client object</param>

        cafm.actions.execute({
            url: cafm.url.api('WorkOrder/Unlock'),
            elementId: cafm.res.consts.ElementId_MainForm,
            loaderSelector: '#centreCol, body.mobile .mainContentPane',
            values: {
                ID: workOrder.ID
            },
            statusCodeFuncs: {
                200: function (w) {

                    // rebind the work order
                    cafm.hd.setWorkOrder(w, true);

                    // refresh the whole form
                    cafm.hd.refreshWorkOrderForm();
                }
            }
        });
    },
    copy: function (workOrder) {
        /// <summary>Function for copying a work order</summary>
        /// <param name="workOrder" type="Object">Work order to copy, if it's an array the first item will be taken</param>

        // if it's an array take the first one as this action is single item only
        if (isArray(workOrder)) {

            workOrder = workOrder[0];
        }

        // load the route by URL as copy work doesn't have it's own navigatable (as it actually loads the new work order form once details are copied)
        cafm.router.loadRoute('~/Helpdesk#copyWorkOrder/{0}'.format(workOrder.ID));
    },
    /// <summary>Offline security container</summary>
    offlineSecurity: {

        isAllowed: function (action) {
            /// <summary>Tests if a work order action is allowed offline</summary>
            /// <param name="action" type="Integer">Work order action enum value</param>
            /// <returns type="Boolean">True if allowed</returns>

            var w = cafm.hd.workOrder,
                ws = w.Security,
                hs = cafm.getClientSettings().helpdeskSettings,
                lcs = cafm.enums.LifeCycleStatus,
                a = cafm.hd.helpers.isPrincipalForWorkOrder(w),
                lwa = cafm.enums.LogWorkOrderAction; // allowed?

            if (!a && !cafm.enums.isSingleEnumValue(action, [lwa.AddLabourCharge, lwa.CompleteLabourCharge, lwa.StartLabourCharge, lwa.AddNote, lwa.EditNote])) return a; // not allowed if not principle and not labour charge action/note action

            switch (action) {

                case lwa.AddNote:
                    a = (cafm.hd.helpers.isAnyEngineer() && ws.Actions.AddNote && [lcs.Completed, lcs.Discarded].indexOf(w.LifeCycleStatus) == -1);
                    break;

                case lwa.EditNote:
                    a = (cafm.hd.helpers.isAnyEngineer() && ws.Actions.EditNote && [lcs.Completed, lcs.Discarded].indexOf(w.LifeCycleStatus) == -1);
                    break;

                case lwa.ViewNotes:
                    a = (cafm.hd.helpers.isAnyEngineer() && ws.Actions.ViewNotes);
                    break;

                case lwa.AddLabourCharge:

                    a = ((cafm.hd.helpers.isAnyEngineer() && hs.labourChargesMode == cafm.enums.LabourChargesMode.Adhoc) || (hs.labourChargesMode > cafm.enums.LabourChargesMode.Adhoc && cafm.hd.helpers.isHelpdeskOperator())) && 
                        cafm.hd.helpers.isAssignedOrTeamLeadForWorkOrder(w) &&
                        cafm.enums.isSingleEnumValue(w.LifeCycleStatus, [lcs.Open, lcs.OnHold]) &&
                        w.WorkStarted != null;
                    break;
                
                case lwa.Complete:

                    a = hdActions.offlineSecurity.isAllowedForWorkOrder(hs.actionComplete, w) &&
                        [lcs.Completed, lcs.Discarded, lcs.OnHold].indexOf(w.LifeCycleStatus) == -1 &&
                        w.WorkStarted != null;
                    break;

                case lwa.CompleteLabourCharge:

                    a = hs.labourChargesMode == cafm.enums.LabourChargesMode.StartEndRealTimeRecording && 
                        cafm.hd.helpers.isAnyEngineer() && 
                        cafm.hd.helpers.isPrincipalOrAssistantForWorkOrder(w) && 
                        cafm.enums.isSingleEnumValue(w.LifeCycleStatus, [lcs.Open, lcs.OnHold]) &&
                        cafm.hd.lc.helpers.hasInProgressLabourChargeForPerson(cafm.auth.personId());

                    break;

                case lwa.PlaceOnHold:

                    a = w.LifeCycleStatus == lcs.Open;
                    break;

                case lwa.RecordTravel:

                    a = ws.Actions.RecordTravel;
                    break;

                case lwa.Resolve:

                    a = hdActions.offlineSecurity.isAllowedForWorkOrder(hs.actionResolve, w) &&
                        [lcs.Completed, lcs.Discarded, lcs.OnHold, lcs.Resolved].indexOf(w.LifeCycleStatus) == -1 &&
                        w.WorkStarted != null;
                    break;
            
                case lwa.Start:

                    a = ws.Actions.Start && w.WorkStarted == null;
                    break;

                case lwa.StartLabourCharge:

                    a = hs.labourChargesMode == cafm.enums.LabourChargesMode.StartEndRealTimeRecording &&
                        cafm.hd.helpers.isAnyEngineer() &&
                        cafm.hd.helpers.isPrincipalOrAssistantForWorkOrder(w) &&
                        cafm.enums.isSingleEnumValue(w.LifeCycleStatus, [lcs.Open, lcs.OnHold]) &&
                        w.WorkStarted != null &&
                        !cafm.hd.lc.helpers.hasInProgressLabourChargeForPerson(cafm.auth.personId());

                    break;

                case lwa.TakeOffHold:

                    a = w.LifeCycleStatus == lcs.OnHold;
                    break;

                default:

                    a = true;
                    break;
            }

            return a;
        },
        isAllowedForWorkOrder: function (actionSource, wo) {
            /// <summary>Tests if a work order action is allowed by work order source</summary>
            /// <param name="actionSource" type="Integer">Source enum value</param>
            /// <param name="wo" type="Object">The work order</param>
            /// <returns type="Boolean">True if allowed</returns>

            return actionSource == cafm.enums.WorkOrderActionSource.All || wo.Source == actionSource;
        }
    },
    helpers: {

        setupActionForm: function (vm, pnl, afterSetup) {
            /// <summary>Helper for setting up a work order action form</summary>
            /// <param name="vm" type="Object">Action view model</param>
            /// <param name="pnl" type="$">Action form container element</param>
            /// <param name="afterSetup" type="Function">Optional after setup handler function - is passed the view model and container element</param>
            
            // bind the view model
            cafm.views.bindActionWindowViewModel(vm);

            // get the action wrapper element
            var pel = isMobile ? pnl : pnl.parents('.actionWindow:first');

            // set the locality
            var loc;
            if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskEditWorkOrder, cafm.enums.Navigatable.HelpdeskConfirmWorkOrder)) {

                loc = cafm.hd.workOrder.LocalityDescription;
            }

            // prepare the action form
            pel.prepareForm(loc);

            // setup the toolbar
            $('.cTb', pel).setupToolbar();

            if (isFunc(afterSetup)) {

                afterSetup(vm, pnl);
            }
        },
        setResolveHoursWorked: function (vm, chargeRate) {
            /// <summary>Sets hours worked using the GetWorkingTime service</summary>
            /// <param name="vm" type="Object">Action view model</param>
            /// <param name="chargeRate" type="Object">Charge rate to apply</param>
            
            // now the value on the form vm
            var vm = cafm.views.getActionWindowViewModel();

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/GetWorkingTime'),
                elementId: 'actionFormPlc',
                loaderSelector: '#actionFormPlc',
                values: {
                    WorkOrderID: vm.get('WorkOrderID'),
                    WorkFinished: vm.get('WorkFinished')
                },
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        // work out total minutes
                        var totalMins = r.TotalMilliseconds / 60000;
                        var hours = r.Hours;
                        var mins = r.Minutes;

                        // bind total time string and milliseconds
                        vm.set('TotalTime', '{0} : {1}'.format(hours, kendo.toString(mins, '00')));
                        vm.set('TimeWorkedMillis', r.TotalMilliseconds);
                        
                        // ensure hour charges object
                        var hc = vm.get('HourCharges');
                        if (!isObj(hc)) {

                            vm.set('HourCharges', {});
                            hc = vm.get('HourCharges');
                        }

                        if (chargeRate) {

                            vm.set('HourCharges.ChargeRateCodeID', chargeRate.ID);
                            vm.set('HourCharges.ChargeRateCodeDescription', chargeRate.Description);
                        }

                        // calculcate overtime mins
                        var otHours = hc.get('OvertimeHours');
                        var otMins = hc.get('OvertimeMinutes');
                        var totalOtMins = 0;
                        if (cafm.util.isNum(otHours)) {

                            totalOtMins += (otHours * 60);
                        }
                        if (cafm.util.isNum(otMins)) {

                            totalOtMins += otMins;
                        }

                        // calculate basic mins remaining from overtime
                        var basicMins = totalMins;
                        if (totalOtMins > 0) {

                            basicMins -= totalOtMins;
                        }

                        // calculate hours mins
                        hours = Math.floor(basicMins / 60);
                        mins = basicMins % 60;

                        // bind basic hours mins
                        hc.set('BasicHours', hours);
                        hc.set('BasicMinutes', mins);
                    }
                }
            });
        },
        endOfflineAction: function (args) {
            /// <summary>Helper for ending an offline action</summary>
            /// <param name="args" type="Object">End action arguments object - options include cacheWorkOrder and refreshToolbar</param>

            if (args.cacheWorkOrder) {

                // this sets the updated work order in the cache, and rebinds
                cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext(true);
            }

            // show offline action message
            cafm.views.showOfflineMessage(true);

            // close the action window
            if(!args.preventCloseWindow)
                hdActions.closeActionWindow(args.refreshToolbar === true);
        },
        getResolvedLifeCycleStatus: function (hs, wo) {
            /// <summary>Helper to get life cycle status once a work order has been resolved</summary>
            /// <param name="hs" type="Object">Helpdesk settings</param>
            /// <param name="wo" type="Object">The work order client object</param>
            /// <returns type="cafm.enums.LifeCycleStatus">Either resolve or completed status</returns>

            var lcs = cafm.enums.LifeCycleStatus;

            if (wo.Source == cafm.enums.WorkOrderActionSource.Planned) {

                return hs.completeResolvedPlannedWorkOrders && !hs.signatureCompletesWorkOrder ? lcs.Completed : lcs.Resolved;
            }
            else if (wo.Source == cafm.enums.WorkOrderActionSource.Reactive) {

                return hs.completeResolvedReactiveWorkOrders && !hs.signatureCompletesWorkOrder ? lcs.Completed : lcs.Resolved;
            }
        }
    },
    handlers: { 

        form: function (e) {

            if (!cafm.hd.workOrder) return;
            var actionEnum = cafm.enums.LogWorkOrderAction[e.button['data-key']];

            switch (actionEnum) {

                case cafm.enums.LogWorkOrderAction.SetMainContact:

                    cafm.lookup.open('mainContact');
                    break;

                case cafm.enums.LogWorkOrderAction.SetOtherContact:

                    cafm.lookup.open('otherContact');
                    break;

                case cafm.enums.LogWorkOrderAction.SetPracticeCode:

                    cafm.lookup.open('practiceCode');
                    break;

                case cafm.enums.LogWorkOrderAction.SetDepartment:

                    cafm.lookup.open('department');
                    break;

                case cafm.enums.LogWorkOrderAction.SetWoType:

                    cafm.lookup.open('workOrderType');
                    break;

                case cafm.enums.LogWorkOrderAction.SetWoGroup:

                    cafm.lookup.open('workOrderGroup');
                    break;

                case cafm.enums.LogWorkOrderAction.SetSwo:

                    cafm.lookup.open('standardWorkOrder');
                    break;

                case cafm.enums.LogWorkOrderAction.SetInternalServiceLevel:

                    cafm.lookup.open('internalServiceLevel');
                    break;

                case cafm.enums.LogWorkOrderAction.SetExternalServiceLevel:

                    cafm.lookup.open('externalServiceLevel');
                    break;

                case cafm.enums.LogWorkOrderAction.AddServiceProvider:

                    cafm.lookup.open('serviceProvider');
                    break;

                case cafm.enums.LogWorkOrderAction.AddTrade:

                    cafm.hd.as.tradesToolbar.add();
                    break;

                case cafm.enums.LogWorkOrderAction.AddTradePerson:

                    cafm.hd.as.tradePeopleToolbar.add();
                    break;

                case cafm.enums.LogWorkOrderAction.AddAsset:

                    cafm.lookup.open('assetLookup');
                    break;

                case cafm.enums.LogWorkOrderAction.AddBcp:

                    cafm.lookup.open('chargeToLookup');
                    break;

                case cafm.enums.LogWorkOrderAction.AddStock:

                    cafm.lookup.open('partLookup');
                    break;

                case cafm.enums.LogWorkOrderAction.UploadNewDocument:
                case cafm.enums.LogWorkOrderAction.AddExistingDocument:
                case cafm.enums.LogWorkOrderAction.AddCost:

                    var winWidth = cafm.util.viewPortWidth(60);
                    var winHeight = cafm.views.actionWindowConfig.medium.height();
                    var vm;

                    if (actionEnum == cafm.enums.LogWorkOrderAction.UploadNewDocument || actionEnum == cafm.enums.LogWorkOrderAction.AddExistingDocument) {
                        winHeight = cafm.views.actionWindowConfig.large.height();
                    }

                    if (actionEnum == cafm.enums.LogWorkOrderAction.AddCost) {
                        vm = {
                            submit: cafm.costs.editToolbar.add,
                            cancel: cafm.costs.editToolbar.cancel,
                            WorkOrderID: cafm.hd.workOrder.get('ID')
                        };
                        winWidth = cafm.util.viewPortWidth(40);
                    }

                    var a = cafm.isMobile() ? e.action : e.item.data('action');
                    var t = cafm.isMobile() ? e.title : $('.k-in', e.item).text();

                    if (actionEnum === cafm.enums.LogWorkOrderAction.AddCost)
                        cafm.costs.prepareFormViewModel(vm);

                    cafm.views.openActionWindow({
                        url: cafm.url.get(a),
                        isForm: true,
                        viewModel: vm,
                        initialText: cafm.res.str.TextPreparingForm,
                        winOptions: {
                            title: t,
                            width: winWidth,
                            height: winHeight
                        }
                    });

                    break;

                case cafm.enums.LogWorkOrderAction.AddNote:
                case cafm.enums.LogWorkOrderAction.AddCustomerRiskAssessment:
                case cafm.enums.LogWorkOrderAction.AddTradePersonRiskAssessment:

                    cafm.views.openChildActionWindow(e);
                    break;

                case cafm.enums.LogWorkOrderAction.Issue:

                    cafm.hd.actions.showIssue(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Accept:

                    cafm.hd.actions.showAccept(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Decline:

                    cafm.hd.actions.showDecline(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Start:

                    cafm.hd.actions.showStart();
                    break;

                case cafm.enums.LogWorkOrderAction.PlaceOnHold:

                    cafm.hd.actions.showPlaceOnHold(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.TakeOffHold:

                    cafm.hd.actions.showTakeOffHold(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.ExtendOnHold:

                    cafm.hd.actions.showExtendOnHold(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Resolve:

                    cafm.hd.actions.showResolve(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Complete:

                    cafm.hd.actions.showComplete(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Discard:

                    cafm.hd.actions.showDiscard(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.ResetStatus:

                    cafm.hd.actions.resetStatus(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.Unlock:

                    cafm.hd.actions.unlock(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.RemoveSelected:

                    var listWrappers = $('#{0} .k-content.k-state-active .cLvWrap:visible'.format(cafm.res.consts.ElementId_FormWidget));

                    listWrappers.each(function (i, el) {

                        var selected = $(el).getSelectedItemUids();
                        if (selected && selected.length) {
                            $('.cTb [data-key="Remove"]', el).click();
                        }
                    });
                    break;

                case cafm.enums.LogWorkOrderAction.RecordTravel:

                    travel.toolbar.addtravel(e.event);
                    break;

                case cafm.enums.LogWorkOrderAction.EndTask:

                    cafm.hd.actions.endTask(cafm.hd.workOrder.toJSON());
                    break;

                case cafm.enums.LogWorkOrderAction.AddViewer:

                    cafm.hd.as.viewersToolbar.add();
                    break;

                case cafm.enums.LogWorkOrderAction.ReassignPerson:

                    cafm.hd.as.historicToolbar.reassignperson();
                    break;

                case cafm.enums.LogWorkOrderAction.AddLabourCharge:

                    cafm.hd.lc.helpers.showAddLabourCharge();
                    break;

                case cafm.enums.LogWorkOrderAction.StartLabourCharge:

                    cafm.hd.lc.helpers.showStartLabourCharge();
                    break;

                case cafm.enums.LogWorkOrderAction.CompleteLabourCharge:

                    cafm.hd.lc.helpers.completeLabourCharge();
                    break;

                case cafm.enums.LogWorkOrderAction.Save:

                    cafm.forms.showFormSection();
                    cafm.hd.saveWoAction().execute();
                    break;

                case cafm.enums.LogWorkOrderAction.Print:

                    cafm.hd.actions.showPrint([cafm.hd.workOrder.toJSON()]);
                    break;
        
                case cafm.enums.LogWorkOrderAction.Email:

                    var link = cafm.url.abs(cafm.res.consts.Url_HelpdeskWorkOrderByRef).format(cafm.hd.workOrder.get('Reference'));
                    var eSubject = cafm.res.str.TemplateWorkOrder0.format(cafm.hd.workOrder.get('Reference'));
                    var eBody = '{0} {1}'.format(eSubject, link);
                    window.location = encodeURI('mailto:?subject={0}&body={1}'.format(eSubject, eBody));
                    break;

                case cafm.enums.LogWorkOrderAction.Copy:

                    cafm.hd.actions.copy(cafm.hd.workOrder);
                    break;

                case cafm.enums.LogWorkOrderAction.RecordTravel:

                    travel.toolbar.addtravel(e.event);
                    break;

                default:

                    if (e.button['data-key'] == cafm.res.consts.DataKey_Cancel) {

                        cafm.router.enablePreRouteChangedHandler(false);
                        cafm.hd.onEndWorkOrderEdit();
                    }
            }
        },
        search:  function (e) {
                
            var woGrid = $('#{0}'.format(cafm.res.consts.ElementId_SearchGrid));
            var workOrders = woGrid.getSelectedGridRows();
            var woAction = cafm.enums.WorkOrderAction[e.button['data-key']];

            if (workOrders.length || woAction == cafm.enums.WorkOrderAction.Export || woAction == cafm.enums.WorkOrderAction.Preview) {

                switch (woAction) {

                    case cafm.enums.WorkOrderAction.Issue:

                        cafm.hd.actions.showIssueMultiple(workOrders, args => {
                            woGrid.refreshGridDataSource();
                            cafm.util.callFunctionAsync({
                                func() {
                                    if (hdActions.hasActionError !== true)
                                        hdActions.closeActionWindow();
                                    if (isFunc(args.action))
                                        args.action();
                                },
                                timeout: hdActions.vars.closeTimeout
                            });
                        });
                        break;

                    case cafm.enums.WorkOrderAction.Resolve:

                        cafm.hd.actions.showResolveMultiple(workOrders, function () {
                            woGrid.refreshGridDataSource();
                            cafm.util.callFunctionAsync({ func: hdActions.closeActionWindow, timeout: hdActions.vars.closeTimeout });
                        });
                        break;

                    case cafm.enums.WorkOrderAction.Complete:

                        cafm.hd.actions.showCompleteMultiple(workOrders, function () {
                            woGrid.refreshGridDataSource();
                            cafm.util.callFunctionAsync({ func: hdActions.closeActionWindow, timeout: hdActions.vars.closeTimeout });
                        });
                        break;

                    case cafm.enums.WorkOrderAction.Preview:

                        cafm.layout.toggleRightColumn();
                        cafm.hd.showWorkOrderPreview();
                        break;

                    case cafm.enums.WorkOrderAction.Export:

                        cafm.filters.exportResults(e.button['data-value']);
                        break;

                    case cafm.enums.WorkOrderAction.Copy:

                        cafm.hd.actions.copy(workOrders);
                        break;

                    case cafm.enums.WorkOrderAction.Print:

                        cafm.hd.actions.showPrint(workOrders);
                        break;
                }
            }
        }
    }
}